    <template>
    <div>
        <b-container class="mb-3">
            <b-row align-h="center">
                <b-col cols="7">
                    <img class="qb-followup-logo" src="https://www.followupcrm.com/hubfs/raw_assets/public/FollowupCRM_November_2022/images/v2_header_logo.png">
                    <img id="and-logo-id" @click="connectWithQB()" class="and-logic-logo mx-4 my-2 cursor-pointer" :class="(isQuickBookConnected)? 'and-logic-logo mx-4 my-2 cursor-pointer':'and-logic-logo mx-4 my-2 cursor-pointer and-logic-logo-red'" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/and-logic-new.png">
                    <img class="qb-logo" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/quickbook-logo.png">
                </b-col>
            </b-row>
        </b-container>
        <b-container>
            <b-row align-h="center">
                <b-col cols="12">
                    <b-card-group deck>
                        <b-card header="Connect QuickBooks" header-tag="header" >
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="12">
                                        <b-form>
<!--                                            <b-form-group id="input-group-1" label="Callback URL / Redirect URI" label-for="clientSecret" >-->
<!--                                                <b-form-input v-model="callBackUrl" id="callBackUrl" type="text" placeholder="Call back url" readonly>-->
<!--                                                </b-form-input>-->
<!--                                            </b-form-group>-->
<!--                                            <b-form-group id="input-group-1" label="Enter your client ID" label-for="clientId" >-->
<!--                                                <b-form-input v-model="clientId" id="clientId" type="password" placeholder="Client ID" :state="clientIdState" :readonly="isQuickBookConnected">-->
<!--                                                </b-form-input>-->
<!--                                            </b-form-group>-->
<!--                                            <b-form-group id="input-group-1" label="Enter your client Secret" label-for="clientSecret" >-->
<!--                                                <b-form-input v-model="clientSecret" id="clientSecret" type="password" placeholder="Client Secret" :state="clientSecretState" :readonly="isQuickBookConnected">-->
<!--                                                </b-form-input>-->
<!--                                            </b-form-group>-->
<!--                                            <b-button type="submit" variant="primary">Save-->
<!--                                            </b-button>-->
                                            <b-button type="button" variant="primary" class="float-left" v-if="!isQuickBookConnected" @click="saveQuickBookCredentials()">Connect
                                            </b-button>
                                            <b-button type="button" variant="danger" class="float-left" v-if="isQuickBookConnected" @click="disconnectQuickBook()">Disconnect
                                            </b-button>
                                        </b-form>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="mt-4">
            <b-row align-h="center">
                <b-col cols="12">
                    <b-card-group deck>
                        <b-card no-body>
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="12" class="p-0">
                                        <b-tabs pills card>
                                            <b-tab title="Custom Fields" active>
                                                <b-card-text>
<!--                                                    <b-form-checkbox-->
<!--                                                        id="checkbox-cost-code"-->
<!--                                                        v-model="costCode"-->
<!--                                                        name="checkbox-cost-code"-->
<!--                                                        value="true"-->
<!--                                                        unchecked-value="false"-->
<!--                                                        class="text-black cursor-pointer"-->
<!--                                                    >-->
<!--                                                        Cost Code-->
<!--                                                    </b-form-checkbox>-->
<!--                                                    <br>-->
                                                    <b-form-checkbox
                                                        id="checkbox-complete-percentage"
                                                        v-model="completePercentage"
                                                        name="checkbox-complete-percentage"
                                                        value="true"
                                                        unchecked-value="false"
                                                        class="text-black cursor-pointer"
                                                    >
                                                        Completed Percentage
                                                    </b-form-checkbox>
                                                </b-card-text>
                                            </b-tab>
                                            <b-tab title="User Management">
                                                <b-card-text>
                                                    <div class="row mt-3">
                                                        <div class="col-2"></div>
                                                        <div class="col-8">
                                                            <multiselect
                                                                :options="users"
                                                                v-model="selectedUsers"
                                                                label="name"
                                                                value="id"
                                                                track-by="id"
                                                                :multiple="true"
                                                                :close-on-select="false"
                                                                :taggable="true"
                                                                id="quickBookSelectedUsers"
                                                                placeholder="Please select users"
                                                            >
                                                            </multiselect>
                                                        </div>
                                                        <div class="col-2"></div>
                                                    </div>
                                                    <div class="row mt-3">
                                                        <div class="col-2"></div>
                                                        <div class="col-8">
                                                            <div class="bg-white rounded p-2">
                                                                <div v-if="selectedUsers.length > 0">
                                                                    <div v-for="(selectedUser, index) in selectedUsers" class="px-2">
                                                                        <span class="text-black font-weight-light">
                                                                            {{selectedUser.name}}
                                                                        </span>
                                                                        <span class="float-right text-red">
                                                                            <i class="fa fa-trash-o cursor-pointer" aria-hidden="true" @click="removeSelectedUser(index)"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-center">
                                                                    No user selected
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-2"></div>
                                                    </div>
                                                </b-card-text>
                                            </b-tab>
                                        </b-tabs>
<!--                                        <b-button type="button" variant="primary" class="float-right mt-4 m-3" @click="saveSettings()">Save</b-button>-->
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
    name: 'quick-book',
    components: {Multiselect},
    props: ['team', 'user', 'activeUsers', 'quickBookSelectedUsers', 'callBackUrl'],
    data(){
        return {
            clientId: this.team.quick_book_client_id ?? '',
            clientSecret: this.team.quick_book_client_secret ?? '',
            isQuickBookConnected: this.team.is_quick_book_connected,
            isCredentialSaved: (this.team.quick_book_client_id && this.team.quick_book_client_secret)? true:false,
            costCode: this.team.quick_book_cost_code,
            completePercentage: this.team.quick_book_complete_percentage,
            users: this.activeUsers.map(user => ({
                id:user.id,
                name:user.name
            })),
            selectedUsers: this.quickBookSelectedUsers ?? []
        }
    },
    methods:{
        connectWithQB(){
            if($('#and-logo-id').hasClass("and-logic-logo-red")){
                this.saveQuickBookCredentials();
            }else{
                $('#and-logo-id').addClass('and-logic-logo-red');
                this.disconnectQuickBook();
            }
        },
        saveQuickBookCredentials(){

            // let checkQuickBookCredentials = false;
            // if(this.clientId.trim() == null || this.clientId.trim() == ''){
            //     checkQuickBookCredentials = true;
            // }
            //
            // if(this.clientSecret.trim() == null || this.clientSecret.trim() == ''){
            //     checkQuickBookCredentials = true;
            // }

            // if(checkQuickBookCredentials){
            //     this.getToast().fire({
            //         type: 'error',
            //         title: 'Please provide a valid QuickBooks keys.'
            //     });
            //     return false;
            // }else{
                let data = {
                    // clientId: this.clientId,
                    // clientSecret: this.clientSecret,
                    isQuickBookConnected: this.isQuickBookConnected
                };
                axios.post(route('quick-book.save-credentials'), data).then((response) => {
                    // this.getToast().fire({
                    //     type: 'success',
                    //     title: response.data.message
                    // });
                    this.clientId = response.data.team.quick_book_client_id ?? '';
                    this.clientSecret = response.data.team.quick_book_client_secret ?? '';
                    this.isQuickBookConnected = response.data.team.is_quick_book_connected;
                    this.isCredentialSaved = true;
                    this.connectQuickBook();
                });
            // }

        },
        connectQuickBook(){
            // $('#and-logo-id').removeClass('and-logic-logo-red');
            axios.post(route('quick-book.connect-quick-book'), {}).then((response) => {
                if(response.data.status == 'success'){
                    $('#and-logo-id').removeClass('and-logic-logo-red');
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(()=>{
                        window.location.href = response.data.authUrl;
                    }, 2000);
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        disconnectQuickBook(){
            axios.post(route('quick-book.disconnect-quick-book'), {}).then((response) => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.isQuickBookConnected = response.data.team.is_quick_book_connected;
            });
        },
        removeSelectedUser(index){
            this.selectedUsers.splice(index, 1);
        },
        saveSettings(){
            this.$nextTick(() => {
                let data = {
                    costCode: this.costCode,
                    completePercentage: this.completePercentage,
                    selectedUsers: this.selectedUsers
                };
                console.log('data', data);
                axios.post(route('quick-book.save-settings'), data).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
            });
        }
    },
    computed: {
        clientIdState() {
            return this.clientId.length > 0 ? true : 'null'
        },
        clientSecretState() {
            return this.clientSecret.length > 0 ? true : 'null'
        }
    },
    watch: {
        'completePercentage': function(value){
            this.$nextTick(() => {
               this.saveSettings();
            });
        },
        'selectedUsers': function(value){
            this.$nextTick(() => {
               this.saveSettings();
            });
        }
    }
}
</script>
<style>
    img.qb-followup-logo {
        width: 100%;
        max-width: 230px;
        height: auto;
    }
    img.qb-logo {
        width: 100%;
        max-width: 230px;
        height: auto;
    }
    img.and-logic-logo {
        width: 100%;
        max-width: 65px;
        height: auto;
        transition: all .3s linear;
        filter: invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(96%) contrast(106%);
    }
    .and-logic-logo-red{
        filter: invert(16%) sepia(99%) saturate(7404%) hue-rotate(4deg) brightness(95%) contrast(118%) !important;
        transform: rotate(35deg);
        transition: all .3s linear;
    }
</style>
